// Duplicated from ab-common
import { notesSetAddingAction, notesUpdateNewNoteAction, notesSetAddingPrivateAction, notesUpdateNewPrivateNoteAction } from '@applyboard/ab-common';
import { applicationAgentFirstName, applicationStudentFirstName, newNoteSelector, permissionsSelector, newPrivateNoteSelector } from '@applyboard/ab-common';
var addingNewNote = function addingNewNote(visibility) {
  return function (dispatch, getState) {
    var state = getState();
    var privateNote = visibility === 'private';
    var agent = applicationAgentFirstName(state);
    var student = applicationStudentFirstName(state);
    var newNote = privateNote ? newPrivateNoteSelector(state) : newNoteSelector(state);
    var permissions = permissionsSelector(state) || {};
    var replyingTo = agent || student;
    var notesUpdate = privateNote ? notesUpdateNewPrivateNoteAction : notesUpdateNewNoteAction;
    var setAdding = privateNote ? notesSetAddingPrivateAction : notesSetAddingAction;
    if (permissions.notes_initialize && visibility === 'public' && newNote.title == null) {
      var info = {
        title: '',
        body: "<p>Hi ".concat(replyingTo, ",</p><p><br></p><p><br></p><p><br></p><p><br></p>"),
        visibility: visibility,
        dirty: false,
        email_user: true,
        restricted: false
      };
      dispatch(notesUpdate(info));
    }
    dispatch(setAdding(true, false, visibility));
  };
};
export default addingNewNote;